import React, { useEffect, useState } from "react";
import dayjs from "dayjs";
import Modal from "../../general/Modal";
import CategoriasSelect from "../../general/CategoriasSelect";
import { downloadFile, request } from "../../../utils/request";
import { gruposDeRespuesta } from "../../../utils/categorias";

const filtrosIniciales = { almacen: '', ubicacion: '', grupos: [], ciego: false };

const ExportarInventario = ({ show, toggle }) => {
    const [almacenes, setAlmacenes] = useState([]);
    const [ubicaciones, setUbicaciones] = useState([]);
    const [arbolGrupos, setArbolGrupos] = useState([]);
    const [cargado, setCargado] = useState(false);
    const [filtros, setFiltros] = useState(filtrosIniciales);
    const [descargando, setDescargando] = useState(false);

    // Las opciones se piden la primera vez que se abre el modal, no al entrar a la lista.
    useEffect(() => {
        if (!show) return;

        setFiltros(filtrosIniciales);

        if (cargado) return;

        setCargado(true);
        request('almacenes').then((res) => setAlmacenes(res?.data ?? []));
        request('ubicaciones').then((res) => setUbicaciones(res?.data ?? []));
        request('grupos?arbol=1').then((res) => setArbolGrupos(gruposDeRespuesta(res)));
    }, [show]);

    const cambiar = (campo, valor) => setFiltros({ ...filtros, [campo]: valor });

    const exportar = async () => {
        if (descargando) return;

        const query = new URLSearchParams();
        if (filtros.almacen) query.append('almacen', filtros.almacen);
        if (filtros.ubicacion) query.append('ubicacion', filtros.ubicacion);
        if (filtros.grupos.length) query.append('grupo', filtros.grupos.join(','));
        if (filtros.ciego) query.append('ciego', 1);

        setDescargando(true);
        await downloadFile('movimientos/exportar?' + query.toString(), 'inventario-' + dayjs().format('YYYY-MM-DD') + '.csv');
        setDescargando(false);

        toggle();
    };

    return <Modal
        show={show}
        toggle={toggle}
        title="Exportar inventario"
        acceptText="Exportar"
        callback={exportar}
        saving={descargando}>
        <div className="form-group">
            <label htmlFor="exportar-almacen">Almacén</label>
            <select id="exportar-almacen" className="form-control" value={filtros.almacen} onChange={(e) => cambiar('almacen', e.target.value)}>
                <option value="">Todos</option>
                {almacenes.map((almacen) => <option key={almacen.id} value={almacen.id}>{almacen.nombre}</option>)}
            </select>
        </div>

        <div className="form-group">
            <label htmlFor="exportar-ubicacion">Ubicación</label>
            <select id="exportar-ubicacion" className="form-control" value={filtros.ubicacion} onChange={(e) => cambiar('ubicacion', e.target.value)}>
                <option value="">Todas</option>
                {ubicaciones.map((ubicacion) => <option key={ubicacion.id} value={ubicacion.id}>{ubicacion.nombre}</option>)}
            </select>
        </div>

        <div className="form-group">
            <label htmlFor="exportar-categorias">Categorías</label>
            <CategoriasSelect
                arbol={arbolGrupos}
                valor={filtros.grupos}
                onChange={(ids) => cambiar('grupos', ids)}
                inputId="exportar-categorias"
                placeholder="Todas"
            />
        </div>

        <div className="form-check">
            <input
                type="checkbox"
                className="form-check-input"
                id="exportar-ciego"
                checked={filtros.ciego}
                onChange={(e) => cambiar('ciego', e.target.checked)}
            />
            <label className="form-check-label" htmlFor="exportar-ciego">Exportar con cantidad en blanco</label>
        </div>
    </Modal>;
};

export default ExportarInventario;
